import '../styles/bgs.css';
import Banner from "../components/About/banner";
import AboutAction from "../components/About/action";
import AboutDocuments from "../components/About/documents";
import AboutRisk from "../components/About/risk";
import AboutContact from "../components/About/contact";
import AboutPartnerProgram from "../components/About/partnerProgram";
import AboutPartnerStart from "../components/About/partnerStart";
import PartnerForm from "../components/Forms/Partner";
import AboutPartnerProgramMobile from '../components/About/AboutPartnerProgramMobile';
import TechPartners from '../components/About/TechPartners';

function About() {
  return (
    <>
      <div className='w-full bg-white overflow-hidden'>
        <div className='container mx-auto px-4 py-8 my-[120px] xl:mb-[65px] xl:mt-[90px]'>
          <Banner />
        </div>
      </div>
      <div className="w-full bg-about-action overflow-hidden">
        <div className='container mx-auto px-4 h-[200px] lg:h-[100px]'>
          <AboutAction />
        </div>
      </div>
      <div className="w-full bg-white overflow-hidden">
        <div className='container mx-auto lg:px-4 mt-[120px] xl:mt-[120px]'>
          <AboutDocuments />
        </div>
      </div>
      <div className="w-full bg-white overflow-hidden">
        <div className='container mx-auto px-4 my-[60px] xl:mt-[50px] xl:mb-[120px]'>
          <AboutRisk />
        </div>
      </div>
      <div className="w-full bg-about-contact overflow-hidden">
        <div className='container mx-auto px-4 my-[60px] xl:my-[30px]'>
          <AboutContact />
        </div>
      </div>

      <div className="w-full bg-white overflow-hidden">
        <div className='container mx-auto px-4 my-[60px] xl:my-[30px]'>
          <TechPartners />
        </div>
      </div>
      {/* <div className="w-full bg-gradient-to-r from-[#202020] via-[#352f2a] to-[#ecb07b] justify-start items-center inline-flex overflow-hidden overflow-hidden">
        <div className='container mx-auto px-4 mb-[43px] hidden lg:block'>
          <AboutPartnerProgram />
        </div>
        <div className='container mx-auto block lg:hidden'>
          <AboutPartnerProgramMobile />
        </div>
      </div>
      <div className="w-full bg-white overflow-hidden">
        <div className='container mx-auto lg:px-4 mt-[120px] lg:mt-[118px]'>
          <AboutPartnerStart />
        </div>
      </div>
      <div className="w-full bg-white overflow-hidden">
        <div id="partner-form" className='container mx-auto px-4 w-full flex justify-center xl:pt-[0px] mb-[120px] xl:mb-[100px]'>
          <PartnerForm />
        </div>
      </div> */}
    </>
  );
}

export default About; 